import { switchAccount, type SwitchAccountParameters, type SwitchAccountReturnType } from '../actions/switchAccount';
import { useContext } from '../context';
import { useConnections } from './useConnections';
import { useMutation, type MutationOptions } from './useMutation';

export type UseSwitchAccountParameters = MutationOptions<SwitchAccountReturnType, SwitchAccountParameters>;

export function useSwitchAccount(parameters?: UseSwitchAccountParameters) {
  const { config } = useContext();

  const mutationFn = async (parameters: SwitchAccountParameters) => {
    return await switchAccount(config, parameters);
  };

  const { mutate, mutateAsync, ...result } = useMutation(mutationFn, parameters);

  return {
    ...result,
    connectors: useConnections().map((connection) => connection.connector),
    switchAccount: mutate,
    switchAccountAsync: mutateAsync,
  };
}
